(function () {
  const selectors = {
    container: "[data-details]",
    content: "[data-details-content]",
    showButton: "[data-details-show]",
    hideButton: "[data-details-hide]"
  };

  const modifiers = {
    open: "view-more--open"
  };

  initViewMore();

  function initViewMore() {
    document.addEventListener("click", onViewMoreClicked);
  }

  function onViewMoreClicked({ target }) {
    const showButton = target.closest(selectors.showButton);
    const hideButton = target.closest(selectors.hideButton);

    if (showButton) {
      showViewMore(showButton);
    }

    if (hideButton) {
      hideViewMore(hideButton);
    }
  }

  function showViewMore(button) {
    const container = button.closest(selectors.container);

    if (!container) {
      return;
    }

    container.classList.add(modifiers.open);

    $(container).find(selectors.content)
      .stop()
      .slideToggle(250, function () {
        $(this).css("height", "");
      });
  }

  function hideViewMore(button) {
    const container = button.closest(selectors.container);

    if (!container) {
      return;
    }

    container.classList.remove(modifiers.open);

    $(container).find(selectors.content)
      .stop()
      .slideToggle(250, function () {
        $(this).css("height", "");
      });
  }
})();
